// extracted by mini-css-extract-plugin
module.exports = {"iconWithMargin":"product-actions-bar-view-iconwithmargin_iconWithMargin__2_FzL"};